export interface IXenaAppPluginTranslation {
  title: string
}
